'use client'

import { useContext, useEffect, useRef, useState } from "react";
import FloatDialog from "./_floatDialog";
import { SignContext } from "@/context/signContext";
import InqueryFooter from "../etc/inqueryFooter";
import SiteShare from "@/components/etc/siteShare";
import { useTranslations } from "next-intl";

export default function FloatLogin() {
    const { loginShow, SetLoginShow, SetSignUpShow, handleLoginSubmit } = useContext(SignContext)
    const [id, setId] = useState<string>("")
    const [password, setPassword] = useState<string>("")

    const formRef = useRef<HTMLFormElement>(null)
    const idInputRef = useRef<HTMLInputElement>(null)

    const t = useTranslations("Text")
    const a = useTranslations("Sentence")

    useEffect(() => {
        if (!loginShow) {
            setId("")
            setPassword("")
            formRef.current?.reset()
        }
    }, [loginShow])

    return (
        <FloatDialog
            show={loginShow}
            setShow={SetLoginShow}
            className="login" >
            <FloatDialog.Head>{t("로그인")}</FloatDialog.Head>
            <FloatDialog.Body>
                <form ref={formRef} onSubmit={e => handleLoginSubmit(e, id, password, () => { SetLoginShow(false) })}>
                    <div className="login-container">
                        <div className="form-body">
                            <input type="text"
                                name="username"
                                placeholder={t("아이디")}
                                onChange={e => setId(e.currentTarget.value)}
                                autoFocus
                            />
                            <input type="password"
                                name="password"
                                placeholder={t("비밀번호")}
                                onChange={e => setPassword(e.currentTarget.value)}
                            />

                        </div>
                        <div className="btns flex center m-b-5">
                            <button className={`w-45-per font-13`} type="submit">{t("로그인")}</button>
                            <button className={`w-45-per font-13`} type="button" onClick={e => SetSignUpShow(true)}>{t("회원가입")}</button>
                        </div>
                        <p>{a("ForgotPassword")}</p>
                        <div className="shareBtn w-45-per">
                            <SiteShare />
                        </div>
                        <InqueryFooter />
                    </div>
                </form>
            </FloatDialog.Body>
        </FloatDialog>
    )
}